import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { MenuGroup } from '@wordpress/components';
/**
 * Internal dependencies
 */

import BlockStylesMenuItems from '../block-styles/menu-items';
export default function BlockStylesMenu(_ref) {
  let {
    hoveredBlock,
    onSwitch
  } = _ref;
  const {
    clientId
  } = hoveredBlock;
  return createElement(MenuGroup, {
    label: __('Styles'),
    className: "block-editor-block-switcher__styles__menugroup"
  }, createElement(BlockStylesMenuItems, {
    clientId: clientId,
    onSwitch: onSwitch
  }));
}
//# sourceMappingURL=block-styles-menu.js.map